import { createBrowserRouter } from "react-router-dom";
import Address from "@src/components/screens/Address";
import AnnualTransactions from "@src/components/screens/AnnualTransactions";
import Citizenship from "@src/components/screens/Citizenship";
import Contact from "@src/components/screens/Contact";
import Employment from "@src/components/screens/Employment";
import Details from "@src/components/screens/Employment/Details";
import SelfEmployed from "@src/components/screens/Employment/SelfEmployed";
import BusinessDetails from "@src/components/screens/Employment/BusinessDetails";
import ErrorPage from "@src/components/screens/Error";
import First from "@src/components/screens/First";
import Identification from "@src/components/screens/Identification";
import IncompleteAttempt from "@src/components/screens/IncompleteAttempt";
import Page404 from "@src/components/screens/Page404";
import ReviewDetails from "@src/components/screens/ReviewDetails";
import Terms from "@src/components/screens/Terms";
import Success from "@src/components/screens/Success";
import StartIdentification from "@src/components/screens/StartIdentification";
import AlmoastDone from "@src/components/screens/AlmoastDone";
// import DoUHavePayunicard from "@src/components/screens/DoUHavePayunicard";
// import CreatePayAccount from "@src/components/screens/CreatePayAccount";
// import PayUnicardTerms from "@src/components/screens/PayUnicardTerms";
import ConnectToken from "@src/components/screens/ConnectToken";
import PurposeOfRelationship from "@src/components/screens/PurposeOfRelationship";
import Otp from "@src/components/screens/Otp";
import Pep from "@src/components/screens/PEP";
import PepDetails from "@src/components/screens/PEP/Details";
import SourceOfIncomeCodes from "@src/components/screens/IncomeSource";
import ExpectedMonthlyIncome from "@src/components/screens/IncomeSource/ExpectedMonthlyIncome";
import B2BTmc from "./components/b2b-tmc";
import TOSLink from "./components/spare-pay";
import PU_KYC from "./components/pu-kyc";

const router = createBrowserRouter([
  {
    path: "/:lang/pu-kyc",
    element: <PU_KYC />,
    errorElement: <Page404 />,
  },
  {
    path: "/:lang/sphere-pay",
    element: <TOSLink />,
    errorElement: <Page404 />,
  },
  {
    path: "/:lang/confirm-tmc",
    element: <B2BTmc />,
    errorElement: <Page404 />,
  },
  {
    path: "/:lang",
    errorElement: <Page404 />,
    children: [
      {
        path: "",
        element: <First />,
      },
      {
        path: "404",
        element: <Page404 />,
      },
      // {
      //   path: "identify-with-payunicard",
      //   element: <DoUHavePayunicard />,
      // },
      {
        path: "terms",
        element: <Terms />,
      },
      {
        path: "start-identification",
        element: <StartIdentification />,
      },
      {
        path: "incomplete-attempt",
        element: <IncompleteAttempt />,
      },
      {
        path: "review-details",
        element: <ReviewDetails />,
      },
      {
        path: "citizenship",
        element: <Citizenship />,
      },
      {
        path: "address",
        element: <Address />,
      },
      {
        path: "employment",
        element: <Employment />,
      },
      {
        path: "employment/details",
        element: <Details />,
      },
      {
        path: "employment/self",
        element: <SelfEmployed />,
      },
      {
        path: "employment/business",
        element: <BusinessDetails />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "otp",
        element: <Otp />,
      },
      {
        path: "almost-done",
        element: <AlmoastDone />,
      },
      // {
      //   path: "create-payunicard-account",
      //   element: <CreatePayAccount />,
      // },
      // {
      //   path: "payunicard-terms",
      //   element: <PayUnicardTerms />,
      // },
      {
        path: "success",
        element: <Success />,
      },
      {
        path: "identification/:session",
        element: <Identification />,
      },
      {
        path: "error",
        element: <ErrorPage />,
      },
      {
        path: "connect-token",
        element: <ConnectToken />,
      },
      {
        path: "purpose-of-relationship",
        element: <PurposeOfRelationship />,
      },
      {
        path: "pep",
        element: <Pep />,
      },
      {
        path: "pep/details",
        element: <PepDetails />,
      },
      {
        path: "source-of-income",
        element: <SourceOfIncomeCodes />,
      },
      {
        path: "expected-monthly-incomes",
        element: <ExpectedMonthlyIncome />,
      },
      {
        path: "annual-transactions",
        element: <AnnualTransactions />,
      },
    ],
  },
]);

export { router };
